module.exports = __webpack_public_path__ + "static/media/31.556aba5e.jpg";